import { Box, ModalHeader } from '@wrisk/ui-components/src'
import React, { FunctionComponent } from 'react'

import { usePolicyholderAdjustment } from '../../../../hooks/adjustments/policyholder'
import { useErrorHandlingAsyncCallback } from '../../../../hooks/errors'
import {
  TExtends,
  TKeyBuilder,
  useWriskTranslation,
} from '../../../../infrastructure/internationalisation'
import { FormConfig } from '../../../../state/configuration'
import { usePolicyholder, usePrincipal } from '../../../authentication'
import { FormDisabled } from '../../../formBuilder'
import { useProposal } from '../../../product/proposal/ProposalProvider'

export interface SaveModalProps {
  tKey: TKeyBuilder
  form: FormConfig
  onSave: () => void
}

export const SaveModal: FunctionComponent<SaveModalProps> = ({ tKey, form, onSave }) => {
  const { t } = useWriskTranslation()
  const { policyholder } = usePolicyholder()
  const { proposal } = useProposal()
  const { apiClient } = usePrincipal()

  const { execute: handleSaveProposal, loading: saveProposalLoading } =
    useErrorHandlingAsyncCallback(async () => {
      await apiClient.saveProposal(proposal.proposalCode)
      onSave()
    })

  const { execute: handleAdjustment, loading: adjustmentLoading } =
    usePolicyholderAdjustment(handleSaveProposal)

  return (
    <Box>
      <ModalHeader
        header={t(tKey('save-modal', 'header'))}
        subheader={t(tKey('save-modal', 'subheader'), { defaultValue: null })}
      />
      <FormDisabled
        id='proposalSave'
        data={policyholder ?? {}}
        config={form}
        onSubmit={handleAdjustment}
        loading={saveProposalLoading || adjustmentLoading}
        tKey={TExtends(tKey, 'form')}
        t={t}
      />
    </Box>
  )
}
